import { render, staticRenderFns } from "./FriendGiftOrder.vue?vue&type=template&id=6b94dce6&scoped=true&"
import script from "./FriendGiftOrder.vue?vue&type=script&lang=js&"
export * from "./FriendGiftOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b94dce6",
  null
  
)

export default component.exports